import React from "react";
import Forbidden from "components/Forbidden";

function ForbiddenPage() {
  return <Forbidden />;
}

export default ForbiddenPage;
